import { ReactNode } from "react";
import { Subject } from "../utils/subject";

export interface ModalParameter {
    id: string;
    title?: string;
    component: ReactNode;
    props?: object;
    parameters: ModalOptions;
}


export interface ModalInternalView {
    id: string;
    title?: string;
    visibility: boolean,
    component: any;
    props?: object;
    parameters: ModalOptions;
    result?: any;
}

export let modalViews: ModalInternalView[] = [];


export const onChange = new Subject();
const onHide = new Subject<string>();

export type ModalSize = "micro" | "small" | "medium" | "large";

interface ModalOptions {
    size: ModalSize;
    canClose?: boolean;
    fill?: {
        width: boolean;
        height: boolean;
    }
}

export const setResult = (id: string, newResult: any) => {
    modalViews = modalViews.map(m => {
        if (m.id == id)
            m.result = newResult;

        return m;
    });

    console.log("modalSystem setResulta", newResult);
}

const listenerEsc = (callback: any) => {
    document.addEventListener('keydown', callback)
}

export const show = async <T>(modalparameter: ModalParameter): Promise<T> => {

    return new Promise<T>((resolve, _) => {
        // clean up result

        let newModal: ModalInternalView = { ...modalparameter, visibility: true, result: undefined };

        let keyDownListener: any;
        const listenerEsc = (evt: any) => {
            if (evt.key === "Escape") {
                hide(modalparameter.id);
            }
        }
        keyDownListener = document.addEventListener('keydown', listenerEsc);

        // const listenerNavigate = () => {
        //     hide(modalparameter.id);
        //     document.removeEventListener('keydown', keyDownListener);
        // }
        //RouteSystem.onNavigate.subscribe(listenerNavigate);

        let onClose = (id: string) => {

            if (id == newModal.id) {

                onHide.unsubscribe(onClose);
                let m = modalViews.find(m => m.id == id);
                if (m)
                    resolve(m.result as T);
                // remove modal from stack
                modalViews = modalViews.filter(m => m.id !== id);
                onChange.emit(undefined);
            }

            document.removeEventListener('keydown', keyDownListener);

        }

        modalViews = [...modalViews, newModal];

        onHide.subscribe(onClose);

        onChange.emit(null);

    })

}

export const hide = (id: string) => {
    console.log("hide", id);
    modalViews = modalViews.map(m => {
        if (m.id == id)
            m.visibility = false;

        return m;
    });

    onHide.emit(id);
}